import { render, staticRenderFns } from "./LeadBoxNonLead.vue?vue&type=template&id=4596adcb&"
import script from "./LeadBoxNonLead.vue?vue&type=script&lang=js&"
export * from "./LeadBoxNonLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports